/**
 * @file 页面数据
 */

export default {
    banner: [
        'https://mms-voice.cdn.bcebos.com/changying/banner_1.png',
        'https://paddlejs.cdn.bcebos.com/website/banner3.png'
    ],
    contain: [
        {
            type: 'news',
            list:  [
                {
                    title: '如何快速get一个冰墩墩头套？',
                    date: '2022-03-21',
                    url: 'https://mp.weixin.qq.com/s/wvX9f-AshaLZZggHaRTZPQ'
                },
                {
                    title: '移动AI系列-web前端利用GPU进行加速计算',
                    date: '2021-12-09',
                    url: 'https://zhuanlan.zhihu.com/p/439866533?utm_source=wechat_session&utm_medium=social&utm_oi=32822895050752&utm_content=group2_article&utm_campaign=shareopn'
                },
                {
                    title: '再添神器！Paddle.js 发布 OCR SDK',
                    date: '2021-12-07',
                    url: 'https://mp.weixin.qq.com/s/KBjXawSfBreUCsIYbUgF-w'
                },
                {
                    title: 'Paddle.js & PaddleClas 实战 ——『寻物大作战』AI 小游戏\n',
                    date: '2021-11-25',
                    url: 'https://mp.weixin.qq.com/s/GP1lc3FZ6lQyD7FJfU67xw'
                },
                {
                    title: '重磅！百度开源 JavaScript 深度学习库',
                    date: '2021-05-14',
                    url: 'https://mp.weixin.qq.com/s/3fxky1Lw6H7HcTVltdtbBg'
                },
                {
                    title: 'JavaScript在小程序网页部署实战',
                    date: '2021-05-11',
                    url: 'https://aistudio.baidu.com/aistudio/education/lessonvideo/1773426'
                }
            ]
        },
        {
            type: 'live',
            title: '线上体验',
            desc: '使用paddle.js在网页体验实时人像分割背景替换及弹幕穿透效果'
        },
        {
            type: 'advantage',
            title: '我们的优势',
            list:  [
                {
                    icon: 'https://paddlepaddle-static.cdn.bcebos.com/paddle-cms-image/144457D76533436AB6FF865D9BDD5B77',
                    title: '多种计算方案',
                    info: '支持WebGL、WebGPU、WASM、CPU、NodeGL多种计算方案调用本地GPU、CPU或服务端算力，加速推理。'
                },
                {
                    icon: 'https://paddlepaddle-static.cdn.bcebos.com/paddle-cms-image/189BC55EB72144A9A999B1E4B21F9E2C',
                    title: '高性能低延迟',
                    info: '提供算子融合、WebGL Pack数据并行计算以及FP16量化等优化策略提升推理性能，降低网络延迟。'
                },
                {
                    icon: 'https://paddlepaddle-static.cdn.bcebos.com/paddle-cms-image/1A6D12CE7A664FE4ACF99562D6FAE591',
                    title: '保障隐私及安全',
                    info: '本地处理用户数据，保证隐私安全；提供全方位模型加密服务，无需担心模型安全问题。'
                },
                {
                    icon: 'https://paddlepaddle-static.cdn.bcebos.com/paddle-cms-image/1B9E818CEFAE4EAA8B912A05AE0BA67D',
                    title: '工具支持',
                    info: '提供数据流处理工具库，支持WebRTC视频流、轻量OpenCV等工具。'
                }
            ]
        },
        {
            type: 'model',
            title: '产品工具集',
            link: 'https://paddlejs.baidu.com/model',
            list:  [
                {
                    title: '图像分类',
                    info: '对数据库中带标签的图像进行分类 (MobileNet)。',
                    url: 'https://github.com/PaddlePaddle/Paddle.js/tree/release/v2.2.2/packages/paddlejs-models/mobilenet'
                },
                {
                    title: '人像分割',
                    info: '实时的人像分割模型。使用者可以用于背景替换(PaddleSeg)。',
                    url: 'https://github.com/PaddlePaddle/Paddle.js/tree/release/v2.2.2/packages/paddlejs-models/humanseg'
                },
                {
                    title: '手势识别',
                    info: 'gesture_detect模型识别图片中人物手掌区域，gesture_rec模型识别人物手势。',
                    url: 'https://github.com/PaddlePaddle/Paddle.js/tree/release/v2.2.2/packages/paddlejs-models/gesture'
                },
                {
                    title: '文本识别',
                    info: 'ocr_detection 模型检测图片中文本所在区域，ocr_recognition 模型可识别每个文本区域内的字符。',
                    url: 'https://github.com/PaddlePaddle/Paddle.js/tree/master/packages/paddlejs-models/ocr'
                }
            ]
        },
        {
            type: 'demo',
            title: '案例展示',
            link: 'https://paddlejs.baidu.com/demo',
            list:  [
                {
                    img: 'https://paddlepaddle-static.cdn.bcebos.com/paddle-cms-image/F960E3FAEABC42BE9A196F6CEE9692EA',
                    title: '物品识别小游戏',
                    info: '基于MobileNet_V2模型，识别常见物品。',
                    code: 'https://mms-voice.cdn.bcebos.com/changying/%E8%AF%86%E7%89%A9%E5%B0%8F%E6%B8%B8%E6%88%8F.jpg',
                    app: '微信app',
                    showCode: false
                },
                {
                    img: 'https://paddlepaddle-static.cdn.bcebos.com/paddle-cms-image/289826D3898D49D9826509C8739999E5',
                    title: '人像分割背景替换',
                    info: '基于PaddleSeg最新人像分割模型，支持百度视频会议实时人像分割背景替换、背景虚化及美颜等效果。',
                    url: 'https://paddlejs.baidu.com/humanStream'
                },
                {
                    img: 'https://mms-voice.cdn.bcebos.com/changying/gesture.png',
                    title: '手势识别AI猜丁壳',
                    info: '基于手势检测&识别模型，支持在h5、小程序中识别剪刀、石头、布、"1"、"ok"等手势。',
                    code: 'https://mms-voice.cdn.bcebos.com/changying/%E5%9C%A3%E8%AF%9EAI%E7%8C%9C%E4%B8%81%E5%A3%B3.png',
                    app: '百度app',
                    showCode: false
                },
                {
                    img: 'https://paddlejs.bj.bcebos.com/website/%E5%B0%81%E9%9D%A2%E5%9B%BE.jpg',
                    title: 'OCR图像中文本识别',
                    info: '基于 ch_PP-OCRv2 模型，可识别图片中通用文本字符（中文、英文、数字）。',
                    url: 'https://paddlejs.baidu.com/ocr'
                }
            ]
        }
    ]
};
